import React from 'react';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import { Divider, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import PriceForm from '../../prices/components/PriceForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxHeight: '85vh',
  width: { xs: '100%', sm: '70%' },
  bgcolor: 'background.paper',
  borderRadius: '15px',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  outline: 'none',
};

export default function ProductPriceModal({
  open,
  onClose,
  mode = 'add',
  isEdit = false,
  productType = 'prepaid',
  initialData = {},
  onSave,
  apiErrors = {},
  isLoading = false,
}) {
  const isView = mode === 'view';
  const title = mode === 'add' ? 'New price' : mode === 'edit' ? 'Edit price' : 'View price';

  const handleSave = (data) => {
    onSave(data);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      className="backdrop-model"
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 2,
              borderBottom: '1px solid',
              borderColor: 'divider',
              flexShrink: 0,
            }}
          >
            <Typography variant="h6" sx={{ ml: 1 }}>
              {title}
            </Typography>
            <IconButton onClick={onClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <PriceForm
              readOnly={mode === 'view'}
              isEdit={isEdit}
              productType={productType}
              initialData={initialData}
              apiErrors={apiErrors}
              isLoading={isLoading}
              onCancel={onClose}
              onSubmit={handleSave}
            />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
